import { useState, useEffect } from "react";
import "./Nav.css";

const NAV_ITEMS = [
  { label: "HOME", id: "home" },
  { label: "SERVICES", id: "services" },
  { label: "CONTACT", id: "contact" },
];

export default function Nav() {
  const [activeId, setActiveId] = useState("home");

  useEffect(() => {
    const observers = [];

    NAV_ITEMS.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (!el) return;

      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setActiveId(id);
          }
        },
        { threshold: 0.5 },
      );

      observer.observe(el);
      observers.push(observer);
    });

    return () => observers.forEach((o) => o.disconnect());
  }, []);

  const handleClick = (e, id) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <nav className="side-nav" aria-label="Main navigation">
      <a href="#home" className="side-nav__brand">
        Mane Consultancy
      </a>
      <ul className="side-nav__list">
        {NAV_ITEMS.map(({ label, id }) => (
          <li key={id} className="side-nav__item">
            <a
              href={`#${id}`}
              className={`side-nav__link${activeId === id ? " side-nav__link--active" : ""}`}
              onClick={(e) => handleClick(e, id)}
            >
              {label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
